module.exports = __webpack_public_path__ + "images/0b60e612c767e6fa778f23545e8b3c95.png";